// client/src/components/modals/AdjustPointsModal.js
import React, { useState } from 'react';
import { Modal, Button, Form, Spinner, Alert } from 'react-bootstrap';
import api from '../../api/axios'; // Use centralized api instance

const AdjustPointsModal = ({ show, onHide, customerId, onSuccess }) => {
    const [changeAmount, setChangeAmount] = useState('');
    const [reason, setReason] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState('');

    const handleSave = async () => {
        setError('');
        if (!changeAmount || !reason) {
            setError('변동 포인트와 사유를 모두 입력해주세요.');
            return;
        }
        if (parseInt(changeAmount, 10) === 0) {
            setError('0이 아닌 값을 입력해주세요.');
            return;
        }

        setIsSaving(true);
        try {
            await api.post(`/customers/${customerId}/points`, {
                changeAmount: parseInt(changeAmount, 10),
                reason
            });
            onSuccess(); // Trigger data refresh on the parent page
            handleClose();
        } catch (err) {
            const message = err.response?.data?.error || '포인트 조정에 실패했습니다.';
            setError(message);
            console.error("Failed to adjust points:", err);
        } finally {
            setIsSaving(false);
        }
    };

    const handleClose = () => {
        setChangeAmount('');
        setReason('');
        setError('');
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>포인트 수동 조정</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>변동 포인트</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="예: 5000 (적립), -3000 (차감)"
                            value={changeAmount}
                            onChange={(e) => setChangeAmount(e.target.value)}
                        />
                        <Form.Text>양수는 적립, 음수는 차감입니다.</Form.Text>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>사유</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="예: 재방문 감사, 포인트 사용 오류 수정"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    취소
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={isSaving}>
                    {isSaving ? <Spinner as="span" size="sm" /> : '저장'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AdjustPointsModal;
